import { plainBtnStyles } from '@/buttons/Plain';
import { css } from '@emotion/react';
import { theme } from './styles/GlobalStyles';

const dynamicStyles = css`
    &[aria-current='page'] {
        color: ${theme.colors.blue3};
    }

    &.current-nav-category {
        color: ${theme.colors.blue3};

        > svg path {
            fill: ${theme.colors.blue3};
        }
    }

    &.current-sub-category {
        color: ${theme.colors.blue3};

        > svg path {
            fill: ${theme.colors.blue3};
        }
    }

    &[data-mobile-expanded],
    &[aria-expanded='true'] {
        > svg {
            transform: rotate(180deg);
        }
    }

    [aria-expanded='true']&.desktop-sub-nav-btn {
        > svg {
            transform: rotate(90deg);
        }
    }

    @media (pointer: fine) {
        :hover {
            color: ${theme.colors.accent3};

            > svg path {
                fill: ${theme.colors.accent3};
            }
        }

        :focus-visible {
            color: ${theme.colors.accent3};

            > svg path {
                fill: ${theme.colors.accent3};
            }
        }
        &.desktop-sub-nav-link {
            :hover {
                background-color: ${theme.colors.blue3};
                color: ${theme.colors.white};

                > svg path {
                    fill: ${theme.colors.white};
                }
            }

            :focus-visible {
                background-color: ${theme.colors.blue3};
                color: ${theme.colors.white};

                > svg path {
                    fill: ${theme.colors.white};
                }
            }
        }
    }
`;

export const navLinkStyles = css`
    ${dynamicStyles};
    text-transform: capitalize;
    color: ${theme.colors.gray6};
    transition: color 0.3s ease-in-out;
    font-size: 1rem;

    // align chevron on right on mobile nav only
    &.chevron-space {
        @media (min-width: 300px) {
            min-width: 260px;

            > svg {
                margin-left: auto;
            }
        }
    }

    @media (min-width: 1280px) {
        margin-bottom: 0 !important;
        font-size: 1.125rem;
    }
`;

export const subNavLinkStyles = css`
    ${navLinkStyles};

    @media (min-width: 1280px) {
        padding: 16px 24px;
        transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    }
`;

export const navBtnStyles = css`
    ${plainBtnStyles};
    ${navLinkStyles};
    font-weight: 400;

    > svg {
        margin-left: 8px;
        transition: transform 0.3s ease-in-out;
        flex-shrink: 0;
        transform: rotate(-90deg);

        path {
            transition: fill 0.3s ease-in-out;
            fill: ${theme.colors.gray6};
        }
    }

    @media (min-width: 1280px) {
        > svg {
            transform: rotate(0);
        }
    }
`;

export const subNavBtnStyles = css`
    ${plainBtnStyles};
    ${subNavLinkStyles};
    font-weight: 400;
    display: flex;
    align-items: center;
    width: 100%;
    text-align: left;

    > svg {
        transform: rotate(-90deg);
        margin-left: 8px;
        transition: transform 0.3s ease-in-out;

        path {
            transition: fill 0.3s ease-in-out;
        }
    }
`;
